import { keyframes, css, cx } from '@emotion/css';

const blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
`;

export const Blink = () => {
  return (
    <div
      className={cx(
        css`
          animation: ${blink} 0.8s ease infinite;
          transform: translateY(2px);
        `,
        'bg-[--ant-primary-color] w-[2px] h-[16px] inline-flex items-center ml-[3px] leading-[20px]',
      )}
    />
  );
};

export const Loading = () => {
  return (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="#bcc3ca"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="#3366ff"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};
